const INITIAL_STATE = {
  voucherEstoqueList: {
    data: []
  },
  voucherEstoque: null,
  voucherTaloes: null,
  voucherEstoquePagination: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'VOUCHERESTOQUE_FETCH':
      return { ...state, voucherEstoqueList: action.payload }
    case 'VOUCHERESTOQUE_SET':
      return { ...state, voucherEstoque: action.payload }
    case 'VOUCHERESTOQUE_GET':
      return { ...state, voucherTaloes: action.payload }
    case 'VOUCHERESTOQUE_PAGINATION':
      return { ...state, voucherEstoquePagination: action.payload }
    default:
      return state
  }
}